// extracted by mini-css-extract-plugin
module.exports = {"selectBox":"Styles_selectBox__w42a9","boxShadowOnlyPC":"Styles_boxShadowOnlyPC__05PBq","wrapper":"Styles_wrapper__K5UHC"};